import { CheckCircle, Clock } from "lucide-react";
import { Timeline } from "@/components/landing/timeline";

const roadmapData = [
  {
    title: "2026",
    content: (
      <div className="max-w-full">
        <p className="mb-6 font-light text-muted-foreground text-sm leading-relaxed md:mb-8 md:text-base">
          Successfully launched VacWork platform with core features and
          AI-powered enhancements.
        </p>
        <div className="mb-6 space-y-2 md:mb-8 md:space-y-3">
          <div className="flex items-start gap-2 text-muted-foreground text-sm md:gap-3 md:text-base">
            <CheckCircle className="mt-0.5 h-4 w-4 shrink-0 text-primary md:h-5 md:w-5" />
            <span>Job search and filtering system</span>
          </div>
          <div className="flex items-start gap-2 text-muted-foreground text-sm md:gap-3 md:text-base">
            <CheckCircle className="mt-0.5 h-4 w-4 shrink-0 text-primary md:h-5 md:w-5" />
            <span>Employer dashboard and job posting</span>
          </div>
          <div className="flex items-start gap-2 text-muted-foreground text-sm md:gap-3 md:text-base">
            <CheckCircle className="mt-0.5 h-4 w-4 shrink-0 text-primary md:h-5 md:w-5" />
            <span>AI-powered job recommendations and candidate matching</span>
          </div>
          <div className="flex items-start gap-2 text-muted-foreground text-sm md:gap-3 md:text-base">
            <CheckCircle className="mt-0.5 h-4 w-4 shrink-0 text-primary md:h-5 md:w-5" />
            <span>Advanced employer analytics and reporting tools</span>
          </div>
        </div>
        <div className="rounded-lg border border-border bg-muted p-4 text-primary md:p-6 dark:text-white">
          <h4 className="mb-2 font-medium text-base md:text-lg">
            Current focus
          </h4>
          <p className="font-light text-sm leading-relaxed opacity-90 md:text-base">
            Building the most comprehensive job matching platform with AI-driven
            insights and seamless user experience.
          </p>
        </div>
      </div>
    ),
  },
  {
    title: "2027",
    content: (
      <div className="max-w-full">
        <p className="mb-6 font-light text-muted-foreground text-sm leading-relaxed md:mb-8 md:text-base">
          Expanding platform capabilities with mobile experience and enterprise
          solutions. Rolling out advanced features for comprehensive recruitment
          management.
        </p>
        <div className="mb-6 space-y-2 md:mb-8 md:space-y-3">
          <div className="flex items-start gap-2 text-muted-foreground text-sm md:gap-3 md:text-base">
            <Clock className="mt-0.5 h-4 w-4 shrink-0 text-primary md:h-5 md:w-5" />
            <span>
              Mobile app for iOS and Android with real-time notifications
            </span>
          </div>
          <div className="flex items-start gap-2 text-muted-foreground text-sm md:gap-3 md:text-base">
            <Clock className="mt-0.5 h-4 w-4 shrink-0 text-primary md:h-5 md:w-5" />
            <span>
              Skill assessment tools and enterprise dashboard for large
              organisations
            </span>
          </div>
          <div className="flex items-start gap-2 text-muted-foreground text-sm md:gap-3 md:text-base">
            <Clock className="mt-0.5 h-4 w-4 shrink-0 text-primary md:h-5 md:w-5" />
            <span>Recruitment assist service for hands-off hiring</span>
          </div>
          <div className="flex items-start gap-2 text-muted-foreground text-sm md:gap-3 md:text-base">
            <Clock className="mt-0.5 h-4 w-4 shrink-0 text-primary md:h-5 md:w-5" />
            <span>Real-time notifications</span>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "2028",
    content: (
      <div className="max-w-full">
        <p className="mb-6 font-light text-muted-foreground text-sm leading-relaxed md:mb-8 md:text-base">
          Launching next-generation features with comprehensive API ecosystem,
          professional development services, and premium subscription offerings
          to enhance the complete career journey.
        </p>
        <div className="mb-6 space-y-2 md:mb-8 md:space-y-3">
          <div className="flex items-start gap-2 text-muted-foreground text-sm md:gap-3 md:text-base">
            <Clock className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground md:h-5 md:w-5" />
            <span>
              API for third-party integrations with HR systems and job boards
            </span>
          </div>
          <div className="flex items-start gap-2 text-muted-foreground text-sm md:gap-3 md:text-base">
            <Clock className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground md:h-5 md:w-5" />
            <span>Career coaching integration with personalised guidance</span>
          </div>
          <div className="flex items-start gap-2 text-muted-foreground text-sm md:gap-3 md:text-base">
            <Clock className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground md:h-5 md:w-5" />
            <span>Premium subscription tiers with advanced features</span>
          </div>
          <div className="flex items-start gap-2 text-muted-foreground text-sm md:gap-3 md:text-base">
            <Clock className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground md:h-5 md:w-5" />
            <span>
              Enhanced AI matching with behavioural and cultural fit analysis
            </span>
          </div>
          <div className="flex items-start gap-2 text-muted-foreground text-sm md:gap-3 md:text-base">
            <Clock className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground md:h-5 md:w-5" />
            <span>International expansion</span>
          </div>
        </div>
        <div className="rounded-lg border border-border bg-muted p-4 text-primary md:p-6 dark:text-white">
          <h4 className="mb-2 font-medium text-base md:text-lg">Coming soon</h4>
          <p className="font-light text-sm leading-relaxed opacity-90 md:text-base">
            Revolutionary features that will transform how people find jobs and
            how companies discover talent worldwide with comprehensive career
            development support.
          </p>
        </div>
      </div>
    ),
  },
];

export function RoadmapSection() {
  return (
    <section className="border-border/50 border-t" id="roadmap">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 md:px-8 md:py-20">
        <div className="mb-12 flex flex-col items-center justify-center space-y-4 text-center md:mb-16 md:space-y-6 lg:mb-20">
          <h2 className="font-light text-2xl leading-tight tracking-tight sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl">
            Our roadmap
          </h2>
          <p className="max-w-3xl text-left font-light text-base text-muted-foreground leading-relaxed sm:text-lg md:text-xl">
            We&apos;ve been building VacWork to revolutionize job searching.
            Here&apos;s our roadmap and what&apos;s coming next.
          </p>
        </div>
      </div>
      <Timeline data={roadmapData} />
    </section>
  );
}
